export default {"src":"/_next/static/media/breathalyser.colour.b0c9ba43.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};